import styled from "styled-components";

export const ReportConfigurationContainer = styled.div`
  width: 100%;
  max-width: 618px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: hidden;
  padding: 16px 8px 16px 16px;
  border: 1px solid ${(props) => props.theme.colors.disabledMeatballItem};
  border-radius: 5px;
`;